export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum ProductCategory {
  WEEKLY_OFFERS = 'weekly_offers',
  NEW_ARRIVAL = 'new_arrival',
  BEST_SELLER = 'best_seller',
  TRENDING = 'trending',
  CLEARANCE = 'clearance',
  FRESH_DAILY = 'fresh_daily',
  FRUITS_VEGETABLES = 'fruits_vegetables',
  GRAINS_PASTA_RICE = 'grains_pasta_rice',
  BAKERY = 'bakery',
  DAIRY_EGGS = 'dairy_eggs',
  CHEESE = 'cheese',
  MILK = 'milk',
  MEAT_POULTRY = 'meat_poultry',
  READY_TO_EAT = 'ready_to_eat',
  DELI = 'deli',
  FRESH_JUICES = 'fresh_juices',
  DATES = 'dates',
  COOKING_ESSENTIALS = 'cooking_essentials',
  BAKING_NEEDS = 'baking_needs',
  SAUCES = 'sauces',
  CANNED_FOOD = 'canned_food',
  SPICES = 'spices',
  FROZEN_FOOD = 'frozen_food',
  ICE_CREAM = 'ice_cream',
  SWEETS = 'sweets',
  SNACKS = 'snacks',
  BREAKFAST = 'breakfast',
  NUTS_DRIED_FRUITS = 'nuts_dried_fruits',
  HONEY_SPREADS = 'honey_spreads',
  SPREADS = 'spreads',
  NOODLES_ASIAN = 'noodles_asian',
  BEVERAGES = 'beverages',
  WATER = 'water',
  JUICES = 'juices',
  COFFEE = 'coffee',
  TEA = 'tea',
  ENERGY_DRINKS = 'energy_drinks',
  PERSONAL_CARE = 'personal_care',
  BEAUTY = 'beauty',
  LAUNDRY = 'laundry',
  HOUSEWARE = 'houseware',
  ELECTRONICS = 'electronics',
  PET_CARE = 'pet_care',
  PHARMACY = 'pharmacy',
  STATIONERY = 'stationery',
  AUTOMOTIVE = 'automotive',
  TOYS_PARTY = 'toys_party',
  MOBILE_ACCESSORIES = 'mobile_accessories',
  FAMILY_SIZE = 'family_size',
  SUPPLEMENTS = 'supplements',
  MEDICAL_DEVICES = 'medical_devices',
  HEALTHY_NUTRITION = 'healthy_nutrition',
}
